import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getProviderWorktime = createAsyncThunk("provdier/get-worktime", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-worktime`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data);
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers worktime");
  }
});

export const updateProviderWorktime = createAsyncThunk(
  "provider/update-worktime",
  async ({ token, worktimeData }, thunkAPI) => {
    try {
      const formData = new FormData();

      worktimeData.forEach((day) => {
        formData.append(`weekday[${day.day}]`, day.checked); // e.g. weekday[Monday]: "Y"
        formData.append(`opening[${day.day}]`, day.opening_hours);
        formData.append(`closing[${day.day}]`, day.closing_hours);
      });

      const res = await axios.post(
        `${BACKEND_URL}/provider/update-worktime`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Update failed");
    }
  }
);


const providerWorktimeSlice = createSlice({
  name: "providerWorktime",
    initialState: {
      providerWorktime: null,
      loading: false,
      error: null,
      message: "",
      
    },
    extraReducers: (builder) => {
      builder
        .addCase(getProviderWorktime.pending, (state) => {
            state.loading = true;
        })
        .addCase(getProviderWorktime.fulfilled, (state, action) => {
            state.providerWorktime = action.payload.providerWorktime;
            state.loading = false;
        })
        .addCase(getProviderWorktime.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch providers worktime"; 
            state.loading = false;
        })
        .addCase(updateProviderWorktime.pending, (state) => {
          state.loading = true;
        })
        .addCase(updateProviderWorktime.fulfilled, (state, action) => {
          state.loading = false;
          state.message = action.payload.message || "Worktime updated successfully!";
        })
        .addCase(updateProviderWorktime.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload || "Update failed";
        })
         },
});

export default providerWorktimeSlice.reducer;